import { FC } from 'react';

interface AdminNavbarListProps {
    isOpen: boolean;
    children?: React.ReactNode;
}

export const AdminNavbarList: FC<AdminNavbarListProps> = ({ isOpen, children }) => {
    return (
        <ul className={`flex flex-col lg:flex-row lg:space-x-4 ${isOpen ? "block" : "hidden"} bg-gray-800`}>
            {children}
        </ul>
    )
}